import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { rootReducer } from 'RiskProfilesApp/features/risk-profiles-shared/state/risk-profiles-new-edit.store';
import { ConfigModule } from 'Angular/config/config.module';
import { SimpleDropdownModule } from 'Angular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { CheckboxGroupModule } from 'Angular/features/components/inputs/checkbox-group/checkbox-group.module';
import { EditInPlaceModule } from 'Angular/features/components/inputs/edit-in-place/edit-in-place.module';
import { EditInWYSIWYGModalModule } from 'Angular/features/components/inputs/edit-in-wysiwyg-modal/edit-in-wysiwyg-modal.module';
import { LoadingSymbolModule } from 'Angular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ConfirmModalModule } from 'Angular/features/components/modals/confirm-modal/confirm-modal.module';
import { HelpModalModule } from 'Angular/features/components/modals/help-modal/help-modal.module';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { PromptModalModule } from 'Angular/features/components/modals/prompt-modal/prompt-modal.module';
import { SharingModalModule } from 'Angular/features/components/modals/sharing-modal/sharing-modal.module';
import { TemplateModalModule } from 'Angular/features/components/modals/template-modal/template-modal.module';
import { TextEditModule } from 'Angular/features/components/modals/text-edit/text-edit.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { PageErrorMessageModule } from 'Angular/features/components/page-error-message/page-error-message.module';
import { ListPagePaginationModule } from 'Angular/features/components/pagination/list-page-pagination/list-page-pagination.module';
import { SideMenuModule } from 'Angular/features/components/side-menu/side-menu.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { IndexOfPipeModule } from 'Angular/features/pipes/index-of/index-of-pipe.module';
import { MetricSelectorModalModule } from 'CalculationsApp/ts/features/metric-selector-modal/metric-selector-modal.module';
import { FoldersSharedModule } from 'FoldersApp/features/folders-shared/app.module';
import { AutocompleteInPlaceModule } from 'SearchApp/ts/features/autocomplete-in-place/autocomplete-in-place.module';
import { GetOwnerDisplayNamePipeModule } from 'SharingApp/ts/pipes/get-owner-display-name.module';
import { GetSharingTooltipMessagePipeModule } from 'SharingApp/ts/pipes/get-sharing-tooltip-message.module';
import { IsSharedWithOthersPipeModule } from 'SharingApp/ts/pipes/is-shared-with-others-pipe.module';
import { getLogger } from 'Angular/state/logger';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class RiskProfilesSharedModule {
}
RiskProfilesSharedModule.ɵfac = function RiskProfilesSharedModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RiskProfilesSharedModule)(); };
RiskProfilesSharedModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: RiskProfilesSharedModule });
RiskProfilesSharedModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AutocompleteInPlaceModule,
        CommonModule,
        CheckboxGroupModule,
        ConfigModule,
        ConfirmModalModule,
        DisabledModule,
        FormsModule,
        GetOwnerDisplayNamePipeModule,
        GetSharingTooltipMessagePipeModule,
        HelpModalModule,
        IconModule,
        IndexOfPipeModule,
        IsSharedWithOthersPipeModule,
        ListPagePaginationModule,
        LoadingSymbolModule,
        MetricSelectorModalModule,
        ModalBaseModule,
        NavigationModule,
        PageErrorMessageModule,
        PromptModalModule,
        SideMenuModule,
        SharingModalModule,
        SimpleDropdownModule,
        StoreModule.forRoot({ rootReducer }, { metaReducers: getLogger() }),
        TemplateModalModule,
        TextEditModule,
        TooltipModule,
        EditInPlaceModule,
        EditInWYSIWYGModalModule,
        FoldersSharedModule] });
